import config from 'config';
import { Bff } from 'core/services';
import { ToolTip } from 'ui/components/compounds';
import { Icon, Card } from 'ui/components/primitives';
import { SUMMARY_COMPONENTS_CONST } from './Summary.components.d';
import { Values } from './Summary.components.styles';
import type { ValuesProps } from './Summary.components.d';

const ValuesBase = ({ bankSlipEmission = true, dataMargin, values }: ValuesProps) => {
  const {
    administrateTax,
    cashback,
    cashbackNum,
    shipping,
    summaryTotal,
    total,
    totalDiscount,
    totalDiscountNum,
  } = values;

  const totalPayment = config.isAdministrateTax && bankSlipEmission ? summaryTotal : total;
  return (
    <Values.Component
      data-margin={dataMargin}
      data-testid={SUMMARY_COMPONENTS_CONST.VALUES_TEST_ID}
    >
      <Card radius="rounded">
        {!!totalDiscountNum && (
          <Values.Row
            data-margin-top="none"
            tabIndex={0}
            aria-label={`Soma dos descontos ${totalDiscount}`}
          >
            <Values.Text>
              Soma dos descontos
              <ToolTip
                align="center"
                content="Soma dos descontos devido a promoções aplicadas no carrinho"
                withIcon
              >
                <Icon.Info size="s" />
              </ToolTip>
            </Values.Text>
            <Values.Text>{totalDiscount}</Values.Text>
          </Values.Row>
        )}

        {!!cashbackNum && (
          <Values.Row>
            <Values.Text>
              {config.cashbackLabel}
              {config.cashbackToolTip && (
                <ToolTip
                  align="center"
                  content="Desconto que você conquistou com seus pedidos do ciclo passado para utilizar no ciclo atual através do programa Eu Posso Mais"
                  withIcon
                >
                  <Icon.Info size="s" />
                </ToolTip>
              )}
            </Values.Text>
            <Values.Text>{cashback}</Values.Text>
          </Values.Row>
        )}
        <Values.Row
          data-margin-top={!totalDiscountNum ? 'none' : ''}
          tabIndex={0}
          aria-label={`Frete ${shipping}`}
        >
          <Values.Text>Frete</Values.Text>
          <Values.Text>{shipping}</Values.Text>
        </Values.Row>

        {config.isAdministrateTax &&
          bankSlipEmission &&
          values?.paymentPlanType === Bff.PAYMENT_PLAN_TYPE.BANK_BILLING && (
            <Values.Row>
              <Values.Text>Emissão do boleto</Values.Text>
              <Values.Text>{administrateTax}</Values.Text>
            </Values.Row>
          )}

        <Values.Divider />

        <Values.Row
          data-margin-bottom="none"
          tabIndex={0}
          aria-label={`Total a pagar ${totalPayment}`}
        >
          <Values.Text data-color="brand-1" data-fontsize="lg">
            Total a pagar
          </Values.Text>
          <Values.Text data-color="brand-1" data-fontsize="lg">
            {totalPayment}
          </Values.Text>
        </Values.Row>
      </Card>
    </Values.Component>
  );
};

export default ValuesBase;
